import React from 'react';
import { FilePickerActiveCaseList } from './file-picker-active-case-list';
import { useQuery } from '@apollo/client';
import {
  CasesSendReportV1FilePickerActiveCaseListContainerCredentialVerificationCasesV1ByApplicantDocument,
  CasesSendReportV1FilePickerActiveCaseListContainerIdentityVerificationCasesV1ByApplicantDocument,
  CasesSendReportV1FilePickerActiveCaseListContainerSendReportCasesV1ByApplicantDocument,
} from '../../../../../../generated';
import { ComponentQueryLoader } from '../../../../../shared/component-query-loader';
import { Empty } from 'antd';

interface FilePickerActiveCaseListContainerProps {
  setCaseInfo: (selectedCaseId: string, selectedCaseType: string) => void;
  applicantName: string;
  applicantId: string;
  selectedTab: string
}

export const FilePickerActiveCaseListContainer: React.FC<FilePickerActiveCaseListContainerProps> = (props) => {
  const {
    data: identityVerificationCasesV1Data,
    loading: identityVerificationCasesV1Loading,
    error: identityVerificationCasesV1Error
  } = useQuery(CasesSendReportV1FilePickerActiveCaseListContainerIdentityVerificationCasesV1ByApplicantDocument, {
    variables: { applicantId: props.applicantId }
  });

  const {
    data: credentialVerificationCasesV1Data,
    loading: credentialVerificationCasesV1Loading,
    error: credentialVerificationCasesV1Error
  } = useQuery(CasesSendReportV1FilePickerActiveCaseListContainerCredentialVerificationCasesV1ByApplicantDocument, {
    variables: { applicantId: props.applicantId }
  });

  const {
    data: sendCasesV1Data,
    loading: sendCasesV1Loading,
    error: sendCasesV1Error
  } = useQuery(CasesSendReportV1FilePickerActiveCaseListContainerSendReportCasesV1ByApplicantDocument, {
    variables: { applicantId: props.applicantId }
  });

  // Combine and format data
  const formattedData = [
    ...(identityVerificationCasesV1Data?.identityVerificationCasesV1ByApplicant?.map((item) => ({
      id: item?.id,
      caseType: item?.caseType,
      state: item?.state,
      caseName: item?.caseName,
      createdAt: item?.createdAt
    })) || []),
    ...(credentialVerificationCasesV1Data?.credentialVerificationCasesV1ByApplicant?.map((item) => ({
      id: item?.id,
      caseType: item?.caseType,
      state: item?.state,
      caseName: item?.caseName,
      createdAt: item?.createdAt
    })) || []),
    ...(sendCasesV1Data?.sendReportCasesV1ByApplicant?.map((item) => ({
      id: item?.id,
      caseType: item?.caseType,
      state: item?.state,
      caseName: item?.caseName,
      createdAt: item?.createdAt
    })) || [])
  ];

  return (
    <ComponentQueryLoader
      loading={identityVerificationCasesV1Loading || credentialVerificationCasesV1Loading || sendCasesV1Loading}
      error={identityVerificationCasesV1Error || credentialVerificationCasesV1Error || sendCasesV1Error}
      hasData={formattedData.length > 0}
      hasDataComponent={<FilePickerActiveCaseList selectedTab={props.selectedTab} cases={formattedData} setCaseInfo={props.setCaseInfo} applicantName={props.applicantName} />}
      noDataComponent={<Empty description="No data available" />}
    />
  );
};